import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import MoodyMonthContent from '../organisms/ProjectsList/MoodyMonthProject/MoodyMonthContent'
import MoodyMonthOverview from '../organisms/ProjectsList/MoodyMonthProject/MoodyMonthOverview'
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials'
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage'
import ContactHelp from '../molecules/ContactHelp/ContactHelp'
import Footer from '../organisms/Footer/Footer'
import { getPageData, useData } from '../../app/helper/functions'

const MoodyMonthPage = () => {
    const { data } = useData();
    const moodyProjectData = getPageData(data, 'moodyProjectPage');

    // Create refs for each section
    const titleRef = useRef(null);
    const contentRef = useRef(null);
    const overviewRef = useRef(null);
    const testimonialsRef = useRef(null);
    const logoRef = useRef(null);
    const contactRef = useRef(null);
    const footerRef = useRef(null);

    // Check if each section is in view
    const titleInView = useInView(titleRef, { once: false, amount: 0.3 });
    const contentInView = useInView(contentRef, { once: false, amount: 0.1 });
    const overviewInView = useInView(overviewRef, { once: false, amount: 0.1 });
    const testimonialsInView = useInView(testimonialsRef, { once: false, amount: 0.3 });
    const logoInView = useInView(logoRef, { once: false, amount: 0.3 });
    const contactInView = useInView(contactRef, { once: false, amount: 0.3 });
    const footerInView = useInView(footerRef, { once: false, amount: 0.3 });

    return (
        <div className='bg-moodyColor'>
            <div className=''>
                <div className='flex justify-center items-center gap-4 pr-4 md:pr-16 pt-28 md:pt-52 pb-6 md:pb-10' ref={titleRef}>
                    <div className='text-white flex flex-col gap-2 relative px-4 md:pl-[9%] text-center'>
                        <motion.div 
                            className='capitalize font-bold text-3xl md:text-6xl'
                            initial={{ opacity: 0, y: -30 }}
                            animate={{ 
                                opacity: titleInView ? 1 : 0, 
                                y: titleInView ? 0 : -30 
                            }}
                            transition={{
                                type: "spring",
                                stiffness: 200,
                                damping: 20
                            }}
                        >
                            Moody Month
                        </motion.div>
                        <motion.div 
                            className='font-medium text-lg md:text-2xl px-2 md:px-[10%]'
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ 
                                opacity: titleInView ? 1 : 0, 
                                y: titleInView ? 0 : 50 
                            }}
                            transition={{
                                type: "spring",
                                stiffness: 100,
                                damping: 15,
                                delay: 0.2
                            }}
                        >
                            Specifically for people who menstruate: How we developed a
                            Application for Moody Month
                        </motion.div>
                    </div>
                </div>
            </div>
            
            <div ref={contentRef}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ 
                        opacity: contentInView ? 1 : 0, 
                        y: contentInView ? 0 : 50 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <MoodyMonthContent moodyProjectData={moodyProjectData}/>
                </motion.div>
            </div>
            
            <div ref={overviewRef}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ 
                        opacity: overviewInView ? 1 : 0, 
                        y: overviewInView ? 0 : 30 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <MoodyMonthOverview moodyProjectData={moodyProjectData}/>
                </motion.div>
            </div>
            
            <div ref={testimonialsRef}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ 
                        opacity: testimonialsInView ? 1 : 0, 
                        y: testimonialsInView ? 0 : 50 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <AppsTestimonials sliderColor='#fff'  color='#2e2e2e' bgUnActiveColor='bg-[#42C7BC]' bgcolor={'bg-darkGreyPrimary'} textColor='white' />
                </motion.div>
            </div>
            
            <div className='p-4 md:p-10 px-4 md:px-36' ref={logoRef}>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ 
                        opacity: logoInView ? 1 : 0, 
                        y: logoInView ? 0 : 30 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <CompanyLogoImage borderColor='border-[#fff]' bgColor='bg-[#2CAB9A]' />
                </motion.div>
            </div>
            
            <div ref={contactRef}>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ 
                        opacity: contactInView ? 1 : 0, 
                        y: contactInView ? 0 : 30 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
                </motion.div>
            </div>
            
            <div ref={footerRef}>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ 
                        opacity: footerInView ? 1 : 0, 
                        y: footerInView ? 0 : 30 
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 100,
                        damping: 15
                    }}
                >
                    <Footer />
                </motion.div>
            </div>
        </div>
    )
}

export default MoodyMonthPage
